import { combineReducers } from 'redux';

import loadBoard from './loadBoard';

export default combineReducers({
  loadBoard
});
